import { useState, useEffect } from 'react';
import { postIpaffsCategories } from '../../../../api/v2/load';
import { useQueryClient, useIsFetching } from '@tanstack/react-query';

export const useIpaffsModalDetailedData = (itemsRows, show) => {
  const [data, setData] = useState({
    data: [],
  });

  const queryClient = useQueryClient();
  const isLoading = useIsFetching({ queryKey: ['postIpaffsCategories', itemsRows] }) > 0;

  useEffect(() => {
    if (itemsRows?.length && show) {
      async function fetchData() {
        const formData = new FormData();
        formData.append('Items', JSON.stringify(itemsRows)); // Convert itemsRows to JSON string
        const dataToSend = { Items: itemsRows }; // Match the backend's expected structure
        try {
          const dataResponse = await queryClient.fetchQuery({
            queryKey: ['postIpaffsCategories', itemsRows],
            queryFn: () => postIpaffsCategories(dataToSend),
            staleTime: Infinity,
          });

          if (!dataResponse) {
            setData([]);
          } else setData(dataResponse);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
      fetchData();
    }
  }, [itemsRows, show]);

  return { data, isLoading };
};
